import { useGetAllCurrenciesQuery } from '$store/modules/currencies';
import { useCurrency } from '$hooks/useCurrency';
import { Dropdown } from 'primereact/dropdown';

const CurrencySelector = () => {
  const { data: currencies, isLoading } = useGetAllCurrenciesQuery();
  const { selectCurrency, selectedCode } = useCurrency();

  if (isLoading || !currencies?.length) return null;

  const options = currencies.map((c) => ({
    ...c,
    label: c.Name,
  }));

  return (
    <Dropdown
      value={selectedCode}
      onChange={(e) => {
        const found = currencies.find((c) => c.Code === e.value);
        if (found) selectCurrency(found);
      }}
      options={options}
      optionLabel="label"
      optionValue="Code"
      aria-label="Select currency"
      className="text-sm"
    />
  );
};

export default CurrencySelector;
